<div class="center">
  <mat-card appearance="outlined" id = "style-4" class="cardcomponentMasks">
    <div class="arx-calendar">
      <iframe  width = "1500" height = "790" src="https://calendar.google.com/calendar/embed?height=800&wkst=2&bgcolor=%23F6BF26&ctz=Europe%2FRome&showTitle=0&showPrint=0&src=MWxjMjk3cGZkZDY3aW11cDM5ZXN2dGc0MjRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&src=aXQuaXRhbGlhbiNob2xpZGF5QGdyb3VwLnYuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%23F4511E&color=%230B8043" style="border:solid 1px #777" frameborder="0" ></iframe>

    </div>
  </mat-card>
</div>
